export default {"src":"/_next/static/media/warranty.f5d9ccf2.svg","height":33,"width":33};